import { render, staticRenderFns } from "./OrderReminders.vue?vue&type=template&id=ef8b76c0&"
import script from "./OrderReminders.vue?vue&type=script&lang=js&"
export * from "./OrderReminders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports